module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/rc/icon_1c0cd0180c6b145d9b17233fed2a8287.png";